import { render, staticRenderFns } from "./orderLook.vue?vue&type=template&id=b09b330c&scoped=true"
import script from "./orderLook.vue?vue&type=script&lang=js"
export * from "./orderLook.vue?vue&type=script&lang=js"
import style0 from "./orderLook.vue?vue&type=style&index=0&id=b09b330c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09b330c",
  null
  
)

export default component.exports